import ButtonGroup from "components/common/ButtonGroup";
import analytics from "utils/analytics";
import googlemaps from "utils/googlemaps";
import lokalise from "utils/lokalise";
import styled from "styled-components";
import { useSearchParams } from 'react-router-dom';
import { useSendWithLoaderConfig } from '../../context/loaderContext';

const Wrapper = styled.div`
    margin: 0.5em;
`;

export default function CardButtons({ googleMapsRouting, setCardFavorite, isFavorite, card, openTripScreenFromCardScreen }) {

    const [params, setParams] = useSearchParams();

    const sendWithLoaderConfig = useSendWithLoaderConfig();

    const leg = googleMapsRouting?.routes[0].legs[0] || null;

    let buttons = [];

    if (card && !card.agency.mode.match(/floating|flight/) && params.get('externalLinks') !== 'false') {
        buttons.push({
            text: lokalise.getKey('button_start_your_trip'),
            iconCategory: "ui",
            iconName: "googleMapsIcon",
            onClick: () => {
                let url;
        
                if (leg) {
                    url = googlemaps.getGMDirectionsURL({
                        startingLocation: { address: leg.start_address },
                        endingLocation: { address: leg.end_address },
                        travelMode: "walking"
                    });
                } else {
                    url = googlemaps.getGMHomeURL();
                }

                sendWithLoaderConfig({ googleMapsUrl: url }, 'google-maps-opened')
        
                // Try to open the URL in a new tab or window
                const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        
                // Fallback for mobile where window.open might be blocked
                if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                    const a = document.createElement("a");
                    a.href = url;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    document.body.appendChild(a);
                    a.click();
                    a.remove(); // remove as it is a one time thing
                }
            }
        });
    }

    if (params.has('favorites') && params.get('favorites') === 'true') {
        buttons.push({
            text: isFavorite ? lokalise.getKey('button_remove_fav') : lokalise.getKey('button_add_fav'),
            iconCategory: "ui",
            iconName: "favoriteAlt",
            onClick: () => {
                // Data drop is in App.js
                setCardFavorite(!isFavorite, card);

                sendWithLoaderConfig({
                    agencyId: card?.agencyId,
                    stopName: card?.stopName,
                    favorited: !isFavorite
                }, 'favorite-selected')
                
            }
        });
    };

    if (card && !card.agency.mode.match(/floating|flight/) && params.has('tripPlan') && params.get('tripPlan') === 'true') {
        // console.log(card);
        buttons.push({
            text: lokalise.getKey('button_plan_your_trip'),
            iconCategory: "ui",
            iconName: "compassAlt",
            onClick: () => {
                if (leg) {
                    const gmap = leg.start_location.toJSON();

                    // analytics.postToDataDrop({
                    //     startingAddress: leg.start_address,
                    //     startingCoords: { latitude: gmap.lat, longitude: gmap.lng }
                    // }, 'Card Screen Button Tap: Plan your trip');

                    sendWithLoaderConfig({
                        startingAddress: leg.start_address,
                        startingCoords: { latitude: Number(gmap.lat).toFixed(3) * 1, longitude: Number(gmap.lng).toFixed(3) * 1 }
                    }, 'plan-your-trip')

                    openTripScreenFromCardScreen({
                        name: leg.start_address,
                        address: leg.start_address,
                        coords: { latitude: gmap.lat, longitude: gmap.lng }
                    });
                } else {
                    openTripScreenFromCardScreen();
                }
            }
        });
    }

    return (
        <Wrapper>
            <ButtonGroup buttons={buttons} />
        </Wrapper>
    )
}